"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        value: 'DJ',
        name: 'DJ',
    },
    {
        value: 'Performer1',
        name: 'Előadóművész',
    },
    {
        value: 'IntermedialPerformer',
        name: 'Intermediális művész',
    },
    {
        value: 'MC',
        name: 'MC',
    },
    {
        value: 'Photographer',
        name: 'Fotós',
    },
    {
        value: 'SoundEngineer',
        name: 'Hangmérnök',
    },
    {
        value: 'Producer',
        name: 'Producer',
    },
    {
        value: 'Singer1',
        name: 'Táncdalénekes',
    },
    {
        value: 'Singer2',
        name: 'Népdalénekes',
    },
    {
        value: 'Director',
        name: 'Rendező',
    },
    {
        value: 'Poet',
        name: 'Költő',
    },
    {
        value: 'Helper',
        name: 'Segítő',
    },
    {
        value: 'Actor',
        name: 'Színész',
    },
    {
        value: 'Actress',
        name: 'Színésznő',
    },
    {
        value: 'Cutter',
        name: 'Vágó',
    },
    {
        value: 'ChorusMaster',
        name: 'Karnagy',
    },
    {
        value: 'ControlEditor',
        name: 'Kontrollszerkesztő',
    },
    {
        value: 'DJ',
        name: 'Keverő',
    },
    {
        value: 'Technician',
        name: 'Road, technikus',
    },
    {
        value: 'LyricsWriter',
        name: 'Szövegíró',
    },
    {
        value: 'Composer',
        name: 'Zeneszerző',
    },
    {
        value: 'SongWriter',
        name: 'Dalszerző',
    },
    {
        value: 'CoverDesigner',
        name: 'Grafikus',
    },
    {
        value: 'Interviewee',
        name: 'Interjúalany',
    },
    {
        value: 'Journalist',
        name: 'Újságíró',
    },
    {
        value: 'Musician',
        name: 'Zenész',
    },
    {
        value: 'MusicianInstr1',
        name: 'Zenész - bandoneónos',
    },
    {
        value: 'MusicianInstr2',
        name: 'Zenész - basszusgitáros',
    },
    {
        value: 'MusicianInstr3',
        name: 'Zenész - bendzsós',
    },
    {
        value: 'MusicianInstr52',
        name: 'Zenész - billentyűs',
    },
    {
        value: 'MusicianInstr4',
        name: 'Zenész - bőgős',
    },
    {
        value: 'MusicianInstr5',
        name: 'Zenész - brácsás',
    },
    {
        value: 'MusicianInstr6',
        name: 'Zenész - buzukis',
    },
    {
        value: 'MusicianInstr7',
        name: 'Zenész - cimbalmos',
    },
    {
        value: 'MusicianInstr8',
        name: 'Zenész - citerás',
    },
    {
        value: 'MusicianInstr9',
        name: 'Zenész - csellós',
    },
    {
        value: 'MusicianInstr10',
        name: 'Zenész - csembalós',
    },
    {
        value: 'MusicianInstr11',
        name: 'Zenész - darbukás',
    },
    {
        value: 'MusicianInstr12',
        name: 'Zenész - didzseridús',
    },
    {
        value: 'MusicianInstr13',
        name: 'Zenész - dobos',
    },
    {
        value: 'MusicianInstr14',
        name: 'Zenész - dorombos',
    },
    {
        value: 'MusicianInstr15',
        name: 'Zenész - dudás',
    },
    {
        value: 'MusicianInstr16',
        name: 'Zenész - énekes',
    },
    {
        value: 'MusicianInstr17',
        name: 'Zenész - fagottos',
    },
    {
        value: 'MusicianInstr18',
        name: 'Zenész - furulyás',
    },
    {
        value: 'MusicianInstr19',
        name: 'Zenész - fuvolás',
    },
    {
        value: 'MusicianInstr53',
        name: 'Zenész - fúvós',
    },
    {
        value: 'MusicianInstr20',
        name: 'Zenész - gadulkás',
    },
    {
        value: 'MusicianInstr21',
        name: 'Zenész - gitáros',
    },
    {
        value: 'MusicianInstr22',
        name: 'Zenész - hárfás',
    },
    {
        value: 'MusicianInstr23',
        name: 'Zenész - harsonás',
    },
    {
        value: 'MusicianInstr24',
        name: 'Zenész - hegedűs',
    },
    {
        value: 'MusicianInstr25',
        name: 'Zenész - klarinétos',
    },
    {
        value: 'MusicianInstr26',
        name: 'Zenész - kobzos',
    },
    {
        value: 'MusicianInstr27',
        name: 'Zenész - kongás',
    },
    {
        value: 'MusicianInstr28',
        name: 'Zenész - kornettes',
    },
    {
        value: 'MusicianInstr29',
        name: 'Zenész - kürtös',
    },
    {
        value: 'MusicianInstr30',
        name: 'Zenész - lantos',
    },
    {
        value: 'MusicianInstr31',
        name: 'Zenész - mandolinos',
    },
    {
        value: 'MusicianInstr32',
        name: 'Zenész - marimbás',
    },
    {
        value: 'MusicianInstr33',
        name: 'Zenész - oboista',
    },
    {
        value: 'MusicianInstr34',
        name: 'Zenész - orgonista',
    },
    {
        value: 'MusicianInstr35',
        name: 'Zenész - steel gitáros',
    },
    {
        value: 'MusicianInstr36',
        name: 'Zenész - szájharmonikás',
    },
    {
        value: 'MusicianInstr37',
        name: 'Zenész - szaxofonos',
    },
    {
        value: 'MusicianInstr38',
        name: 'Zenész - szintetizátoros',
    },
    {
        value: 'MusicianInstr39',
        name: 'Zenész - szitáros',
    },
    {
        value: 'MusicianInstr40',
        name: 'Zenész - tablás',
    },
    {
        value: 'MusicianInstr41',
        name: 'Zenész - tamburás',
    },
    {
        value: 'MusicianInstr42',
        name: 'Zenész - tangóharmonikás',
    },
    {
        value: 'MusicianInstr43',
        name: 'Zenész - tárogatós',
    },
    {
        value: 'MusicianInstr44',
        name: 'Zenész - tekerőlantos',
    },
    {
        value: 'MusicianInstr45',
        name: 'Zenész - trombitás',
    },
    {
        value: 'MusicianInstr51',
        name: 'Zenész - tubás',
    },
    {
        value: 'MusicianInstr46',
        name: 'Zenész - ütőgardonos',
    },
    {
        value: 'MusicianInstr47',
        name: 'Zenész - ütőhangszeres',
    },
    {
        value: 'MusicianInstr54',
        name: 'Zenész - rapper',
    },
    {
        value: 'MusicianInstr48',
        name: 'Zenész - vibrafonos',
    },
    {
        value: 'MusicianInstr55',
        name: 'Zenész - vokalista',
    },
    {
        value: 'MusicianInstr49',
        name: 'Zenész - xilofonos',
    },
    {
        value: 'MusicianInstr50',
        name: 'Zenész - zongorista',
    },
    {
        value: 'presenter',
        name: 'Műsorvezető',
    },
];
